import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-hostelinfrastructure',
    templateUrl: './hostelinfrastructure.component.html',
    styleUrls: ['./hostelinfrastructure.component.scss']
})
export class HostelinfrastructureComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Infrastructure: Building the Foundation of Excellence');
        this.meta.updateTag({
            name: 'description',
            content: `Explore ARNI Infrastructure, designed to support cutting-edge learning, research, and development. A strong foundation for fostering academic growth and success.`
        });
    }

}
